import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import dayjs from 'dayjs';
import { AuthStore } from '../stores/auth.store';

export const expiredGuard: CanActivateFn = (): boolean | UrlTree => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  const user = authStore.currentUser();

  if (!user?.expireDate) {
    return router.createUrlTree(['']);
  }

  const isValid = dayjs().isBefore(user.expireDate as string | Date);

  return isValid ? true : router.createUrlTree(['']);
};
